
<div class="hub-title">Intranet App Hub</div>
<br>
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="hub-container">
    @for (app of apps; track app) {
      <div class="app-tile" (mouseenter)="flipCard(app)" (mouseleave)="flipCard(app)">
        <div class="card" [class.flipped]="app.flipped" (click)="navigateTo(app.link)">
          <div class="front">
            <mat-icon class="app-icon">{{ app.icon }}</mat-icon>
            <h3>{{ app.name }}</h3>
          </div>
          <div class="back">
            <p class="desc">{{ app.description }}</p>
            <span class="explore-text">Click to View</span>
          </div>
        </div>
      </div>
    }
  </div>
  <br>
    <hr class="hr">
    <br>
      <div class="hub-title-two">Additional Safety Apps</div>
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="hub-container">
        @for (depApp of depApps; track depApp) {
          <div class="app-tile" (mouseenter)="flipCard(depApp)" (mouseleave)="flipCard(depApp)">
            <div class="card" [class.flipped]="depApp.flipped" (click)="navigateTo(depApp.link)">
              <div class="front">
                <mat-icon class="app-icon">{{ depApp.icon }}</mat-icon>
                <h3>{{ depApp.name }}</h3>
              </div>
              <div class="back">
                <p class="desc">{{ depApp.description }}</p>
                <span class="explore-text">Click to View</span>
              </div>
            </div>
          </div>
        }
      </div>



